export const IconRightArrow = `<svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_7995_485)">
<path d="M15.7747 13.2114L22.0845 7.19727L15.7747 0.788818" stroke="#3A3D4B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.3945 7.09863H0.788818" stroke="#3A3D4B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_7995_485">
<rect width="22.8732" height="14" fill="white"/>
</clipPath>
</defs>
</svg>
`